// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__ZLS+r","icon":"Notification_icon__wrE6d","message":"Notification_message__1F9mV"};